import { Languages } from "lucide-react";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ReactSelect, { components } from "react-select";
import logoImgUrl from "./assets/images/logo_full.png";
import navbarTogglerMenu from "./assets/images/menu_icon.png";

export function Header({ token }) {
  const { t, i18n } = useTranslation("global");

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <div title={t("header.changeLanguage")}>
          <Languages />
        </div>
      </components.DropdownIndicator>
    );
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logoImgUrl} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              border: "none",
            }}
          >
            <span
              className="navbar-toggler-icon"
              style={{
                backgroundImage: `url(${navbarTogglerMenu})`,
              }}
            ></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul
              className="navbar-nav"
              style={{
                color: "#6A2481",
                textAlign: "right",
                fontFamily: "Poppins",
                fontSize: "18.5px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "normal",
                textTransform: "uppercase",
              }}
            >
              {/* Seção: Contatos importantes */}
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/contatos"
                  data-bs-target=".navbar-collapse.show"
                  style={{
                    color: "#6A2481",
                    textAlign: "right",
                    fontFamily: "Poppins",
                    fontSize: "18.5px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "normal",
                  }}
                >
                  {/* Contatos importantes */}
                  {t("header.contatosImportantes")}
                </Link>
              </li>

              <hr style={{ background: "#E8335E" }}></hr>

              {/* Seção: Aprenda primeiros socorros */}
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/treinamentos"
                  style={{
                    color: "#6A2481",
                    textAlign: "right",
                    fontFamily: "Poppins",
                    fontSize: "18.5px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "normal",
                  }}
                >
                  {/* Aprenda primeiros socorros */}
                  {t("header.aprendaPrimeirosSocorros")}
                </Link>
              </li>

              <hr></hr>

              {/* Seção: Registrar acidente */}
              {token && (
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    aria-current="page"
                    to="/acidente"
                    style={{
                      color: "#6A2481",
                      textAlign: "right",
                      fontFamily: "Poppins",
                      fontSize: "18.5px",
                      fontStyle: "normal",
                      fontWeight: "700",
                      lineHeight: "normal",
                    }}
                  >
                    {/* Registre aqui o acidente */}
                    {t("header.registreAquiAcidente")}
                  </Link>
                </li>
              )}

              <hr></hr>

              <li>
                <ReactSelect
                  components={{ DropdownIndicator }}
                  isRtl={false}
                  placeholder={t("header.changeLanguage")}
                  isSearchable={false}
                  options={[
                    { value: "pt_pt", label: t("header.languagePT") },
                    { value: "pt_br", label: t("header.languageBR") },
                  ]}
                  defaultValue={{
                    value: i18n.language,
                    label: t(`header.language${i18n.language === "pt_pt" ? "PT" : "BR"}`),
                  }}
                  onChange={(e) => i18n.changeLanguage(e.value)}
                  formatOptionLabel={(country) => (
                    <div className="flex items-center justify-center">
                      <ReactCountryFlag
                        countryCode={country.value === "pt_pt" ? "PT" : "BR"}
                        style={{ fontSize: "1em", verticalAlign: "top" }}
                        title={country.label}
                        svg
                      />{" "}
                      <span>{country.label}</span>
                    </div>
                  )}
                />
              </li>

              {/* <hr></hr> */}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
